<template>
  <statistik-base :value="value" :stats="isAsesor ? stats.slice(1) : stats"></statistik-base>
</template>

<script>
import StatistikBase from '@/components/shared/StatistikBase';
export default {
  name: 'Statistik',
  components: { StatistikBase },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isAsesor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stats: [
        {
          icon: 'mdi-file-move',
          color: 'indigo',
          label: 'Kandidat',
          key: '1',
          grid: { cols: 12, md: 4 },
        },
        {
          icon: 'mdi-file-check',
          color: 'success',
          label: 'Esai Sudah dinilai',
          key: '3',
          grid: { cols: 12, md: this.isAsesor ? 6 : 4 },
        },
        {
          icon: 'mdi-file-excel',
          color: 'red',
          label: 'Esai Belum dinilai',
          key: '2',
          grid: { cols: 12, md: this.isAsesor ? 6 : 4 },
        },
      ],
    };
  },
};
</script>

<style scoped></style>
